// ------------------------------------
// FOTOS (CARROSSEL)
// ------------------------------------
$(function () {
  const dots =
    $(".produto-det-foto").length > 1 && $(".produto-det-foto").length <= 10;
  // Carrosel fotos
  $(".grupo-logo").slick({
    lazyLoad: "ondemand",
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    dots: false,
    arrows: false,
    fade: true,
    swipe: false,
    asNavFor: ".nav-icons",
    responsive: [
      // Tablet & Mobile
      {
        breakpoint: 960,
        settings: {
          fade: false,
        },
      },
    ],
  });
  // Carrosel thumbs
  $(".nav-icons").slick({
    slidesToShow: 7,
    focusOnSelect: true,
    infinite: false,
    arrows: false,
    swipe: false,
    useTransform: false,
    asNavFor: ".grupo-logo",

    // Responsivo
    responsive: [
      // Tablet & Mobile
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 7,
        },
      },
    ],
  });
});
